
const digest = '75c5ad179fd3b70704cbbb05bb63f8d0806902106454a8171bd31d75f1deba3d';
const classes = {"input":"_input_idpjx_1"};
const css = `._input_idpjx_1 {
  width: -webkit-fill-available;
  min-height: 55px;
  font-family: Poppins, sans-serif;
  font-size: 14px;
  font-weight: 400;
  padding: 16px 20px;
  color: #000;
  flex: 1;
  border: 1px solid #c1cbe4 !important;
  border-radius: 15px;
  box-shadow: inset 0 3px 0 0 rgba(198, 214, 240, 0.5);
  background-color: #dce7fa;
  position: relative;
}
._input_idpjx_1:disabled {
  background-color: #f3f3f3;
  opacity: 1;
}
._input_idpjx_1:focus {
  box-shadow: 0 0 0 3px rgba(22, 101, 216, 0.15), inset 0 4px 0 0 rgba(226, 229, 237, 0.3);
  border-color: #1665d8;
  background-color: #dce7fa;
  color: #000;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  